
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26.232 23.165"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1469"}},[_c('path',{attrs:{"data-name":"Path 1263","d":"M23.031 5.518v-4.22A1.3 1.3 0 0021.1.167 30.188 30.188 0 018.5 3.949l-4.067.02a1.982 1.982 0 00-1.966 1.747h-.824A1.645 1.645 0 000 7.359v3.608a1.645 1.645 0 001.643 1.643h.828a1.984 1.984 0 001.167 1.578l2.945 8.128a1.289 1.289 0 001.208.846h2.956a1.285 1.285 0 001.208-1.724l-2.53-6.98a30.147 30.147 0 0111.672 3.7 1.289 1.289 0 001.294-.013 1.284 1.284 0 00.64-1.118v-4.22a3.675 3.675 0 000-7.289zM2.457 11.345h-.814a.376.376 0 01-.376-.376v-3.61a.376.376 0 01.376-.376h.813zm1.69 1.684a.713.713 0 01-.422-.65v-6.43a.713.713 0 01.712-.712h3.45v7.856H4.392a.665.665 0 01-.246-.064zm6.618 8.844a.014.014 0 010 .017.015.015 0 01-.015.008H7.792a.018.018 0 01-.017-.011l-2.728-7.528H8.04zm11-4.845a.023.023 0 01-.014.025.029.029 0 01-.034 0 31.418 31.418 0 00-12.563-3.892V5.167a31.426 31.426 0 0012.562-3.892.03.03 0 01.034 0 .023.023 0 01.014.024zm1.267-5.5V6.801a2.409 2.409 0 010 4.723z","fill":"#fff"}})])])
          )
        }
      }
    